import React from 'react'
import QuickGuide from '../components/QuickGuide'
import hipladeTemplate from '../../common/template'

function Guide() {
  return <QuickGuide />
}

export default hipladeTemplate(Guide)